var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 0,
    height: 0,
    fill: "none",
    viewBox: "0 0 25 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.726 4.38H5.683l-.758-2.75C4.804 1.216 4.5.896 4.106.8L1.468.031C1.377 0 1.256 0 1.165 0 .649 0 .164.384.043.895c-.091.32-.03.64.121.928.152.287.394.48.698.575l2 .576 4.095 15.573c-.576.287-.97.927-.97 1.63 0 .992.788 1.823 1.728 1.823s1.728-.831 1.728-1.823v-.064h8.34v.064c0 .992.788 1.823 1.728 1.823s1.729-.831 1.729-1.823c0-.927-.667-1.694-1.516-1.79-2.063-.352-10.523-.768-10.523-.768l-.273-1.151H19.45c.545 0 1.03-.384 1.152-.927l2.274-8.474h.85c.697 0 1.273-.608 1.273-1.343 0-.736-.576-1.343-1.274-1.343"
  })));
};
export default SvgCart;